var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b_article_single simple-page"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"article_wrapper"},[_c('div',{staticClass:"wrapper_inner"},[_c('div',{staticClass:"article_section"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('content-builder',{attrs:{"value":_vm.content}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }